module.exports = __webpack_public_path__ + "img/ESiegeTower64_ua.a3513ed5.webp";